import { render, staticRenderFns } from "./category-featured.vue?vue&type=template&id=20d418cd&scoped=true&lang=pug"
import script from "./category-featured.vue?vue&type=script&lang=js"
export * from "./category-featured.vue?vue&type=script&lang=js"
import style0 from "./category-featured.vue?vue&type=style&index=0&id=20d418cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d418cd",
  null
  
)

export default component.exports